import { render, staticRenderFns } from "./TypeProductMessage.vue?vue&type=template&id=36ca0f3d&scoped=true"
import script from "./TypeProductMessage.vue?vue&type=script&lang=js"
export * from "./TypeProductMessage.vue?vue&type=script&lang=js"
import style0 from "./TypeProductMessage.vue?vue&type=style&index=0&id=36ca0f3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca0f3d",
  null
  
)

export default component.exports